import React, { FC, useRef } from 'react';
import styled from 'styled-components';

import { IconBase } from '@column/column-ui-kit';

interface PasskeyIconProps {
  className?: string;
}

const Wrapper = styled.div``;

export const PasskeyIcon: FC<PasskeyIconProps> = ({ className }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <Wrapper ref={wrapperRef} className={className}>
      <IconBase viewportSize={24}>
        <path
          d="M8.294 10.7049C8.294 10.5419 8.162 10.4109 8 10.4109C7.837 10.4119 7.706 10.5439 7.706 10.7059C7.706 10.8689 7.838 10.9999 8 10.9999C8.162 10.9999 8.294 10.8679 8.294 10.7049"
          stroke="var(--icon-color, currentColor)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 10.411V5.5C8 4.119 9.119 3 10.5 3V3C11.881 3 13 4.119 13 5.5V6.072"
          stroke="var(--icon-color, currentColor)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1621 15.183C10.9691 15.741 11.9451 16.072 13.0001 16.072C13.6621 16.072 14.2901 15.937 14.8681 15.703L17.8771 18.708C18.0651 18.895 18.3191 19 18.5831 19H20.0001C20.5521 19 21.0001 18.552 21.0001 18V16.588C21.0001 16.322 20.8941 16.068 20.7061 15.88L17.6621 12.84C17.8721 12.289 18.0001 11.697 18.0001 11.072C18.0001 8.31102 15.7611 6.07202 13.0001 6.07202C12.2161 6.07202 11.4841 6.26802 10.8241 6.59002"
          stroke="var(--icon-color, currentColor)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.00424 15.268C5.44724 15.025 4.92124 14.686 4.46524 14.23C2.51224 12.277 2.51224 9.11196 4.46524 7.15896C6.41824 5.20596 9.58324 5.20596 11.5362 7.15896C13.4892 9.11196 13.4892 12.277 11.5362 14.23C11.0822 14.684 10.5582 15.021 10.0042 15.264L10.0072 19.501C10.0072 19.767 9.90224 20.021 9.71424 20.209L8.71624 21.207C8.32524 21.598 7.69224 21.598 7.30224 21.207L6.30024 20.205C6.11324 20.018 6.00724 19.764 6.00724 19.499L6.00424 15.268Z"
          stroke="var(--icon-color, currentColor)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    </Wrapper>
  );
};
